﻿import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DetailListRowSkeleton, TabListSkeleton } from "@/components/skeletons";
import { isFeaturePermitted } from "@/utils/functions/rbac";
import { NO_USER_ASSIGNED } from '@/utils/constants/messages';
import { getUserId } from '@/utils/functions/TokenFunction';

interface RoleUsersProps {
    roleUsers: any;
    getUserDetails: (id: string) => void;
    isLoading: boolean;
    dataLoad: boolean;
}

const RoleUsers: React.FC<RoleUsersProps> = (props) => {
    const currentUserId = getUserId();

    const onDeleteClicked = (id: string) => {
        props.getUserDetails(id);
    };

    const [isViewUserPermitted, setIsViewUserPermitted] = useState(false);
    const [isUpdateUserPermitted, setIsUpdateUserPermitted] = useState(false);

    useEffect(() => {
        setIsViewUserPermitted(isFeaturePermitted("AdminPortalViewUser"));
        setIsUpdateUserPermitted(isFeaturePermitted("AdminPortalUpdateUser"));
    }, []);

    return (
        <div>
            <div>
                {props.roleUsers && !props.isLoading ? (
                    props.roleUsers.length > 0 ? (
                        <div className="gs-list-page-card">
                            <ul className="gs-detail-list">
                                {props.roleUsers.map((user: any, key: string) => {
                                    return (
                                        <li className="gs-detail-list-item" key={key}>
                                            <div className="gs-detail-list-name">
                                                <Link className="text-primary hover:underline" to={`/user/${user?.id}`} id={`role-deatil-user-tab-name-${key}`}>
                                                    {user.email_address}
                                                </Link>
                                            </div>
                                            <div className="gs-detail-list-action">
                                                {isViewUserPermitted &&
                                                    isUpdateUserPermitted &&
                                                    user?.id !== currentUserId && (
                                                        <a href={"#"} className="link-primary p-0">
                                                            <em
                                                                id={`role-detail-user-tab-delete-icon-${key}`}
                                                                className="icon ni ni-trash"
                                                                onClick={() => onDeleteClicked(user?.id)}
                                                            />
                                                        </a>
                                                    )}
                                            </div>
                                        </li>
                                    );
                                })}
                                {props.dataLoad && (
                                    <DetailListRowSkeleton className="gs-detail-list-item" />
                                )}
                            </ul>
                        </div>
                    ) : (
                        <span className="gs-detail-list-item text-sm text-card-foreground" id='role-detail-user-tab-no-data-message'>{NO_USER_ASSIGNED}</span>
                    )
                ) : (
                    <TabListSkeleton id="role-user-tab" />
                )}
            </div>
        </div>
    );
};

export default RoleUsers;
